 <video [id]="'videoplayer_'+id"  class="video-js vjs-big-play-centered" controls preload="auto" >
    <p class="vjs-no-js">  
      To view this video please enable JavaScript, and consider upgrading to a
      web browser that
      <a href="http://videojs.com/html5-video-support/" target="_blank">
        supports HTML5 video
      </a>
    </p>
  </video>
  